import React from 'react';

type BurgerMenuItem = {
  label: string;
  onClick: () => void;
};

type BurgerMenuSectionProps = {
  title: string;
  items: BurgerMenuItem[];
};

export const BurgerMenuSection = ({ title, items }: BurgerMenuSectionProps) => (
  <section className="burger-menu-section">
    <div className="burger-menu-title">{title}</div>
    <div className="burger-menu-nav-list">
      {items.map((item, index) => (
        <div key={index}>
          <button className="burger-menu-nav-btn" onClick={item.onClick}>
            {item.label}
          </button>
          {index !== items.length - 1 && <div className="burger-menu-nav-divider" />}
        </div>
      ))}
    </div>
  </section>
);
